import React from "react";
import { FormLayout, Modal, Text, TextField } from "@shopify/polaris";

export default function RecommendationIncreaseModal({
  closeRecommendationIncreaseModal,
  recommendationIncreaseModalOpen,
  handleAutofill,
  increaseByPercentage,
  increaseByQuantity,
  handleIncreaseByPercentageChange,
  handleIncreaseByQuantityChange,
}: {
  readonly closeRecommendationIncreaseModal: () => void;
  readonly recommendationIncreaseModalOpen: boolean;
  readonly handleAutofill: (options?: { percentIncrease?: number; quantityIncrease?: number }) => void;
  readonly increaseByPercentage: number;
  readonly increaseByQuantity: number;
  readonly handleIncreaseByPercentageChange: (value: string) => void;
  readonly handleIncreaseByQuantityChange: (value: string) => void;
}): React.ReactElement {
  return (<Modal
    onClose={closeRecommendationIncreaseModal}
    open={recommendationIncreaseModalOpen}
    primaryAction={{
      content: "Copy recommendations",
      onAction: () => {
        handleAutofill({ percentIncrease: increaseByPercentage, quantityIncrease: increaseByQuantity });
        closeRecommendationIncreaseModal();
      },
    }}
    secondaryActions={[{ content: "Cancel", onAction: closeRecommendationIncreaseModal }]}
    title="Copy with increase"
  >
    <Modal.Section>
      <FormLayout>
        <Text as="p">Increase the quantity of the recommendations by a percentage and / or a fixed quantity.</Text>
        <FormLayout.Group>
          <TextField
            autoComplete="off"
            label="Increase by %"
            onChange={handleIncreaseByPercentageChange}
            suffix="%"
            value={increaseByPercentage?.toString() || ""}
          />
          <TextField
            autoComplete="off"
            label="Increase by quantity"
            onChange={handleIncreaseByQuantityChange}
            suffix="pieces"
            value={increaseByQuantity?.toString() || ""}
          />
        </FormLayout.Group>
      </FormLayout>
    </Modal.Section>
  </Modal>);
};
